import { useState } from 'react'
import { useIntl } from 'react-intl'
import { styled } from '@mui/material'
import { Button } from '../../../components/buttons'
import AlertDialog from '../../../components/dialogs/AlertDialog'
import Tooltip from '../../../components/tooltips/Tooltip'

type Props = {
  disabled: boolean
  // 削除確認ダイアログの本文（呼び出し側で i18n 済みの文言を渡す）。
  confirmMessage: string
  onConfirm: () => void
  // 無効時に削除できない理由をツールチップ表示する（任意・i18n 済み文言）。
  disabledReason?: string
}

// 単票共通の削除ボタン（確認ダイアログ付き）。配置・余白は呼び出し側で調整する。
export const DeleteButton = ({
  disabled,
  confirmMessage,
  onConfirm,
  disabledReason,
}: Props) => {
  const intl = useIntl()
  const [open, setOpen] = useState(false)
  return (
    <>
      {/* 無効なボタンはイベントを発火しないため span で包んでツールチップを出す。 */}
      <Tooltip message={disabled ? disabledReason : undefined}>
        <span>
          <StyledButton
            variant="outlined"
            colorPattern="pink"
            size="s"
            disabled={disabled}
            onClick={() => setOpen(true)}
          >
            {intl.formatMessage({ id: 'dialog.delete' })}
          </StyledButton>
        </span>
      </Tooltip>
      <AlertDialog
        isOpen={open}
        message={confirmMessage}
        submitButtonTitle={intl.formatMessage({ id: 'dialog.delete' })}
        submitHandler={() => {
          setOpen(false)
          onConfirm()
        }}
        closeButtonTitle={intl.formatMessage({ id: 'dialog.cancel' })}
        closeHandler={() => setOpen(false)}
      />
    </>
  )
}

// 保存ボタンと同じ幅に揃える。
const StyledButton = styled(Button)({
  minWidth: '100px',
})
